var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2316 2.75501L19.1699 16.505C19.2431 16.6317 19.2816 16.7754 19.2816 16.9217C19.2816 17.0679 19.2431 17.2117 19.1699 17.3383C19.0968 17.465 18.9916 17.5702 18.8649 17.6434C18.7382 17.7165 18.5945 17.755 18.4483 17.755H2.57159C2.42531 17.755 2.28161 17.7165 2.15493 17.6434C2.02825 17.5702 1.92306 17.465 1.84992 17.3383C1.77678 17.2117 1.73828 17.0679 1.73828 16.9217C1.73828 16.7754 1.77679 16.6317 1.84993 16.505L9.78826 2.75501C9.8614 2.62834 9.9666 2.52315 10.0933 2.45001C10.22 2.37688 10.3637 2.33838 10.5099 2.33838C10.6562 2.33838 10.7999 2.37688 10.9266 2.45001C11.0533 2.52315 11.1584 2.62834 11.2316 2.75501ZM4.01493 16.0883H17.0049L10.5099 4.83834L4.01493 16.0883ZM9.67659 13.5883H11.3433V15.255H9.67659V13.5883ZM9.67659 7.75501H11.3433V11.9217H9.67659V7.75501Z",
    fill: "#F34018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.98ac5b387858def2070c43445b8595b7.svg";
export { ForwardRef as ReactComponent };